// custom js

document.addEventListener('DOMContentLoaded', function () {
  const tags = document.querySelectorAll('.tag-bag-blog');
  const loadMoreBtn = document.querySelector('.load-more-btn .button');
  const blogArticles = document.querySelector('.blog-articles');
  tags.forEach(tag => {
    tag.addEventListener('click', function () {
       // Remove the 'active' class from all tags
    tags.forEach(t => t.classList.remove('active'));

    // Add the 'active' class to the clicked tag
    tag.classList.add('active');

      const selectedTag = this.textContent.trim();

      // Scroll to the blog articles section
      blogArticles.scrollIntoView({ behavior: 'smooth' });

      // Check if articles with the tag are visible; if not, click "Load More" button
/*       if (!isTagInView(selectedTag)) {
        loadMoreBtn.click();
      } */
    });
  });

});